import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { URLs } from '../constants/URLS';

@Injectable()
export class EncryptRSAService {
  key!: CryptoKey;
  constructor(private readonly httpClient: HttpClient) {
    this.httpClient.get<JsonWebKey>(`${URLs.base}${URLs.jwkRsa}`).subscribe({
      next: (jsonWebKey) => this.setKey(jsonWebKey)
    });
  }

  async toEncrypt(data: string): Promise<string> {
    try {
      const raw = await this.toRawEncrypt(data);
      return this.getBase64UrlSafe(raw);
    } catch (e) {
      throw e;
    }
  }

  private async setKey(jsonWebKey: JsonWebKey) {
    this.key = await crypto.subtle.importKey(
      'jwk',
      jsonWebKey,
      { name: 'RSA-OAEP', hash: { name: 'SHA-256' } },
      false,
      ['encrypt']
    );
  }

  private async toRawEncrypt(data: string): Promise<ArrayBuffer> {
    const textEncoder = new TextEncoder();
    try {
      const encryptedData = await crypto.subtle.encrypt(
        { name: 'RSA-OAEP' },
        this.key,
        textEncoder.encode(data)
      );
      return encryptedData;
    } catch (error) {
      throw error;
    }
  }

  private readonly getBase64UrlSafe = (data) => {
    const encriptadoB64 = window.btoa(
      String.fromCharCode.apply(null, Array.from(new Uint8Array(data)))
    );
    return encriptadoB64.replace(/\+/g, '-').replace(/\//g, '_');
  };
}
